import React, {useMemo, useState} from 'react'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import InputBase from '@mui/material/InputBase'
import {Tooltip} from '@mui/material'
import './SearchPhraseForm.scss'
import {useFullSearchParams} from '../../search/searchResultPage/useFullSearchParams'

export const SearchPhraseForm = ({
                                     tooltipMessage = '',
                                     placeholder = 'Search',
                                     onSearch,
                                     inputTestId = '',
                                     searchButtonTestId = ''
                                 }: {
    tooltipMessage?: string,
    onSearch: (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement>, inputText: string) => void
    placeholder?: string,
    inputTestId?: string,
    searchButtonTestId?: string
}) => {
    const {phrase} = useFullSearchParams()
    const [inputText, setInputText] = useState('')
    const [isSearchDisabled, setSearchDisabled] = useState(true)
    const [displayTooltip, setDisplayTooltip] = useState(false)

    useMemo(() => {
        if (phrase != inputText) setInputText(phrase)
    }, [phrase])

    const inputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event?.target?.value
        setSearchDisabled(value.length < 3)
        if (!isSearchDisabled || !value.length) setDisplayTooltip(false)
        setInputText(value)
    }

    const onSearchClick = (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLElement>) => {
        event.preventDefault()
        if (isSearchDisabled) {
            setDisplayTooltip(true)
        } else onSearch(event, inputText)
    }
    return (
        <form className="searchbar" onSubmit={event => onSearchClick(event)}>
            <Tooltip open={displayTooltip && isSearchDisabled}
                     title={tooltipMessage} arrow>
                <InputBase
                    sx={{ml: 1, flex: 1}}
                    placeholder={placeholder}
                    onChange={inputHandler}
                    value={inputText}
                    inputProps={{'data-testid': inputTestId}}
                    className={`input-container ${isSearchDisabled ? 'inactive' : ''}`}
                />
            </Tooltip>
            <IconButton aria-label="header-search-icon" className={`search-icon ${isSearchDisabled ? 'disabled' : ''}`}
                        disableRipple={true} type="submit" onClick={event => onSearchClick(event)}
                        data-testid={searchButtonTestId}>
                <SearchIcon/>
            </IconButton>
        </form>
    )
}